// extracted by mini-css-extract-plugin
module.exports = {"link":"XmQw8","root":"_1CnXL","label":"_1Ch0m"};